//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import ItemId from '@models/ItemId';
import { UniversalItemType } from '@models/UniversalItemType';
import { Opaque } from '@utils/opaque';

type PartialCuid = Opaque<string, 'PartialCuid'>;

function PartialCuidFactory(pCuid: string) {
  return pCuid as PartialCuid;
}

const PartialCuid = Object.assign(PartialCuidFactory, {
  build({ itemType, id }: { itemType: UniversalItemType; id: ItemId }) {
    return PartialCuidFactory(`${itemType}.${id}`);
  },
  buildFromNetworkItem({
    network,
    id,
  }: {
    network: UniversalItemType;
    id: ItemId;
  }) {
    return PartialCuidFactory(`${network}.${id}`);
  },
  parse(pCuid: PartialCuid) {
    const [itemType, itemId] = pCuid.split('.');

    return {
      itemType: itemType as UniversalItemType,
      itemId: itemId as ItemId,
    };
  },
});

export default PartialCuid;
